import type { ConceptDef } from '../types';

export const intraverbalFunction: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-function',
  label: 'Intraverbal Function',
  category: 'Intraverbal',
  description: 'Hear a function question; tap the matching item.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'What do you sit on?', answer: '🪑 chair' },
      { say: 'What do you sleep in?', answer: '🛏 bed' },
      { say: 'What do you drink from?', answer: '🥛 cup' },
      { say: 'What do you eat with?', answer: '🍴 fork' },
      { say: 'What do you write with?', answer: '✏ pencil' },
      { say: 'What do you wear on your feet?', answer: '👟 shoe' },
    ],
  },
};
